import type { PlatformPos } from "./types";

/**
 * La caja offline APAGADA: lo que ve el resto de la app cuando no hay caja.
 *
 * Es la caja de la web (D5: la web vende online) y también la del escritorio
 * mientras el flag `OFFLINE_ENABLED` de Unleash no la prende (ver `cajaOffline.ts`).
 * Nada de esto toca el disco, el llavero ni la red: `isAvailable` es `false` y lo
 * que pregunta el resto de la app (la terminal, el estado, la cola) contesta
 * "no hay". Lo que sólo tiene sentido con caja (dar de alta, registrar una venta,
 * buscar en la foto) rechaza: quien lo llama tiene que haber mirado `isAvailable`.
 */

const posNotAvailable = () =>
  Promise.reject(
    new Error("La caja offline no está habilitada en este equipo")
  );

const SIN_CAJA = {
  conexion: "desconocida",
  bloqueo: null,
  terminalId: null,
  sinConexionDesde: null,
  ultimoLatidoEn: null,
  pendientes: 0,
  mandatoId: null,
  razonSinMandato: null,
} as const;

export const posApagada: PlatformPos = {
  isAvailable: false,
  getTerminal: () => Promise.resolve(null),
  prepareTerminal: posNotAvailable,
  confirmTerminal: posNotAvailable,
  startHeartbeat: () => Promise.resolve(),
  stopHeartbeat: () => Promise.resolve(),
  heartbeatNow: () => Promise.resolve(),
  getStatus: () => Promise.resolve({ ...SIN_CAJA }),
  onStatus: () => Promise.resolve(() => {}),
  saveCart: () => Promise.resolve(),
  listCarts: () => Promise.resolve([]),
  deleteCart: () => Promise.resolve(),
  recordSale: posNotAvailable,
  takeBatch: () => Promise.resolve(null),
  reportBatch: () => Promise.resolve(),
  retrySales: () => Promise.resolve(0),
  queueSummary: () =>
    Promise.resolve({
      pendientes: 0,
      enPendiente: 0,
      masVieja: null,
      ultimaSeqGenerada: 0,
      ultimaSeqSubida: 0,
    }),
  listQueue: () => Promise.resolve([]),
  unprintedSales: () => Promise.resolve([]),
  markPrinted: () => Promise.resolve(),
  updateBlocked: () => Promise.resolve(false),
  photoStatus: () =>
    Promise.resolve({
      partes: [],
      bajando: null,
      sinFoto: false,
      lista: false,
    }),
  onPhoto: () => Promise.resolve(() => {}),
  storeStatus: () =>
    Promise.resolve({ disponible: false, error: null, colaApartada: null }),
  searchPhoto: posNotAvailable,
  scanPhoto: posNotAvailable,
  mandateStatus: () =>
    Promise.resolve({
      vigente: null,
      vencido: false,
      esperandoHoja: false,
      cajerosConPin: [],
      vendidoSinRed: "0",
    }),
  setPin: posNotAvailable,
  verifyPin: posNotAvailable,
  pinEntries: () => Promise.resolve([]),
  photoSettings: () => Promise.resolve(null),
  photoItems: posNotAvailable,
  photoBuyers: () => Promise.resolve([]),
};
